export enum Mutations {
    sendTrainingEmail = 'sendTrainingEmail',
    sendOrganizationEmail = 'sendOrganizationEmail',
}
